import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceType } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-check-payment-method-modal',
  templateUrl: './check-payment-method-modal.html',
  styleUrl: './check-payment-method-modal.scss',
  standalone: false
})
export class CheckPaymentMethod {
  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.CheckPaymentMethod.component = CheckPaymentMethod;
